import { useEffect, useState } from 'react';
import { BRAND_LOGO } from '@/constants/brand';

const navLinks = [
  { label: 'Konzepte', href: '#konzepte' },
  { label: 'Material', href: '#material' },
  { label: 'Über mich', href: '#ueber-mich' },
  { label: 'In der Praxis', href: '#praxis' },
  { label: 'Vergleich', href: '#vergleich' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Bücher', href: '#buecher' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 bg-background-50 transition-shadow duration-300 ${
        scrolled ? 'border-b border-background-200' : 'border-b border-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-7xl h-24 md:h-28 flex items-center justify-between gap-4">
          <a href="#top" className="flex items-center shrink-0 cursor-pointer">
            <img
              src={BRAND_LOGO}
              alt="Ganzheitliche Persönlichkeitsentwicklung – Stephanie Wolf"
              title="Stephanie Wolf – Ganzheitliche Persönlichkeitsentwicklung"
              className="h-16 md:h-20 w-auto"
            />
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="whitespace-nowrap text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#kontakt"
              className="whitespace-nowrap rounded-full bg-primary-500 text-background-50 px-5 py-2.5 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
            >
              Termin buchen
            </a>
          </div>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer"
            aria-label="Menü öffnen"
          >
            <i
              className={`text-2xl text-foreground-900 ${
                menuOpen ? 'ri-close-line' : 'ri-menu-line'
              }`}
            ></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 pb-5 pt-2">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 px-3 text-foreground-800 text-sm font-medium hover:bg-background-100 rounded-md cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#kontakt"
              onClick={() => setMenuOpen(false)}
              className="mt-2 rounded-full bg-primary-500 text-background-50 px-5 py-3 text-sm font-semibold text-center cursor-pointer"
            >
              Termin buchen
            </a>
          </div>
        </div>
      )}
    </header>
  );
}